<template>
  <div>
    Auto - Moto
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'AutoMoto'
}
</script>
